import { DefaultColumnValues, ICsvColumn } from '../../../../../api/connections.dao';
import { TObject } from '../../../../../infrastructure/type-extensions';
import { convertBoolTypeForMixPanel } from '../../../../../tracking-service/tracking-values';

const connectionHeaderStringMap = {
    [DefaultColumnValues.CONNECTION_LEVEL]: 'Connection Level',
    [DefaultColumnValues.DATE]: 'Date',
    [DefaultColumnValues.START_TIME]: 'Start Time',
    [DefaultColumnValues.END_TIME]: 'End Time',
    [DefaultColumnValues.EXTERNAL_ORG_IDS]: 'External Org IDs',
    [DefaultColumnValues.ROOM_PRESENTERS]: 'Room Presenters',
    [DefaultColumnValues.CONNECTION_NOTES]: 'Connection Notes',
    [DefaultColumnValues.CONNECTION_TYPE]: 'Connection Type',
    [DefaultColumnValues.CONNECTION_NAME]: 'Connection Name',
    [DefaultColumnValues.CONNECTION_LINK]: 'Connection Link',
    [DefaultColumnValues.ALTERNATIVE_LINK]: 'Alternative Link',
    [DefaultColumnValues.HOST_LINK]: 'Host Link',
    [DefaultColumnValues.CONNECTION_ID]: 'Connection ID',
    [DefaultColumnValues.CONNECTION_PASSCODE]: 'Connection Passcode',
    [DefaultColumnValues.CONNECTION_ACCOUNT]: 'Connection Account',
    [DefaultColumnValues.SIP]: 'SIP',
    [DefaultColumnValues.CONNECTION_HOST_KEY]: 'Connection Host key',
    [DefaultColumnValues.DIAL_FOR_VS]: 'Dial via VS',
    [DefaultColumnValues.CONNECTION_TOPIC]: 'Connection Topic',
    [DefaultColumnValues.MEETING_INVITATION]: 'Meeting Invitation',
    [DefaultColumnValues.SHOWCASE_PAGE_PATH]: 'Showcase page path',
    [DefaultColumnValues.KNOVIO_ACCOUNT]: 'Knovio Account',
    [DefaultColumnValues.KNOVIO_EMBED_CODE_ID]: 'Knovio embedded Code ID',
    [DefaultColumnValues.KNOVIO_NAME]: 'Knovio Name',
    [DefaultColumnValues.IS_LIVESTREAM]: 'is Livestream',
    [DefaultColumnValues.PRIMARY_RTMP]: 'Primary RTMP',
    [DefaultColumnValues.BACKUP_RTMP]: 'Backup RTMP',
    [DefaultColumnValues.PRIMARY_STREAM_NAME]: 'Primary Stream Name',
    [DefaultColumnValues.BACKUP_STREAM_NAME]: 'Backup Stream name',
    [DefaultColumnValues.IS_DEFAULT]: 'is Default',
    [DefaultColumnValues.ROOM_NAME]: 'Room Name',
    [DefaultColumnValues.ROOM_LABEL]: 'Room label',
    [DefaultColumnValues.ROOM_ID]: 'Room ID',
    [DefaultColumnValues.MEETING_ID]: 'Meeting ID',
    [DefaultColumnValues.ATTENDEE_EMAIL_ADDRESS]: 'Attendee Email Address',
};


export class MixPanelTrackingEventMapper {
    public static get connectionHeaderStringMap(): TObject<string> {
        return connectionHeaderStringMap;
    }
    public static connectionCsvColumnsToTrackingEvent(columns: ICsvColumn[]): Record<string, 'Yes' | 'No'> {
        const eventData = {};
        for (const col of columns) {
            const key = this.connectionColumnHeaderToString(col.header);
            if (key) {
                eventData[key] = this.connectionHeaderValueToString(col.included);
            }
        }

        return eventData;
    }

    private static connectionColumnHeaderToString(header: DefaultColumnValues): string {
        return this.connectionHeaderStringMap[header] || '';
    }
    private static connectionHeaderValueToString(value: ICsvColumn['included']): 'Yes' | 'No' {
        return convertBoolTypeForMixPanel(value) as ('Yes' | 'No');
    }
}
